var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.53583 9.38837L3.53552 9.38868L4.94973 10.8029L14.1421 1.6105L12.7279 0.196289L4.95004 7.97415L1.41421 4.43833L0 5.85254L3.53583 9.38837Z"}));
}

Check.defaultProps = {"width":"15","height":"11","viewBox":"0 0 15 11","fill":"none"};

module.exports = Check;

Check.default = Check;
